import { render, staticRenderFns } from "./MerchantUserUpdate.vue?vue&type=template&id=1249fd38&"
import script from "./MerchantUserUpdate.vue?vue&type=script&lang=js&"
export * from "./MerchantUserUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports